import clsx from "clsx";
import type { CSSProperties } from "react";
import type { IconName } from "./Icon.icons";

type IconSizePreset = "default" | "smaller";
export type IconVariant = "outlined" | "filled";

interface IconProps {
  name: IconName;
  variant?: IconVariant;
  size?: IconSizePreset | number;
  color?: string;
  style?: CSSProperties;
  className?: string;
}

const presetMap: Record<IconSizePreset, number> = {
  default: 24,
  smaller: 20,
};

function resolveSize(size: IconSizePreset | number): number {
  return typeof size === "number" ? size : presetMap[size];
}

function clampOpsz(px: number): number {
  if (px <= 20) return 20;
  if (px >= 48) return 48;
  return px;
}

const ICON_CLASS =
  "inline-block align-middle whitespace-nowrap not-italic normal-case font-normal leading-none tracking-normal antialiased " +
  "[font-family:'Material_Symbols_Outlined'] [word-wrap:normal] [direction:ltr]";

export function Icon({ name, variant = "outlined", size = "default", color, style, className }: IconProps) {
  const px = resolveSize(size);
  const mergedStyle: CSSProperties = {
    ...(color ? { color } : {}),
    ...style,
    fontSize: px,
    fontVariationSettings: `"FILL" ${variant === "filled" ? 1 : 0}, "opsz" ${clampOpsz(px)}`,
  };
  return (
    <span className={clsx(ICON_CLASS, className)} style={mergedStyle}>
      {name}
    </span>
  );
}
